import {
  Button,
  Collapse,
  Empty,
  Form,
  message,
  Modal,
  Popconfirm,
  Skeleton,
  Space,
  Spin,
  Tabs,
} from "antd";
import {
  UserOutlined,
  UserAddOutlined,
  EditOutlined,
  FormOutlined,
  EnterOutlined,
  CalendarOutlined,
  PlusOutlined,
  BookOutlined,
} from "@ant-design/icons";
import styles from "./Student.module.css";
import "./Student.css";
import SignUpInputs from "../../Components/SignUpInputs/SignUpInputs";
import { useState } from "react";
import { useEffect } from "react";
import dayjs from "dayjs";
import PlacementTestForm from "../../Components/PlacementTestForm/PlacementTestForm";
import { useParams } from "react-router-dom";
import api, { url } from "../../api/api";
import * as actions from "../../store/actions/action";
import { connect } from "react-redux";
import StatusSetter from "../../util/StatusSetter";
import TermForm from "../../Components/TermForm/TermForm";
import TextEditor from "../../Components/TextEditor/TextEditor";
import FormExportDropdown from "../../Components/FormExportDropdown/FormExportDropdown";
import SignUpFormMapper from "../../util/SignUpFormMapper";
import { PageHeader } from "@ant-design/pro-components";
import useLevels from "../../hooks/useLevels";

const Student = ({
  ErrorSetter,
  ClearError,
  LoadingSetter,
  ClearLoading,
  token,
  loading,
}) => {
  const [SignUpForm] = Form.useForm();
  const [NewTermForm] = Form.useForm();
  const [editMode, setEditMode] = useState(false);
  const [activeCollapse, setActiveCollapse] = useState("");
  const [activeTab, setActiveTab] = useState("SignUp");
  const [data, setData] = useState(null);
  const [terms, setTerms] = useState(null);
  const [notes, setNotes] = useState(null);
  const [openNewTermModal, setOpenNewTermModal] = useState(false);
  const params = useParams();
  const {LevelSetter , levels} = useLevels()

  const ToggleEditMode = () => {
    setEditMode(!editMode);
  };
  const { Panel } = Collapse;
  const AuthHeader = { Authorization: "Token " + token };
  const fetchData = () => {
    api
      .get(`/student/${params.id}`, { headers: { ...AuthHeader } })
      .then((res) => {
        setData(res.data);
        setNotes(res.data.considerations);
        console.log(res.data.placement_tests);
      })
      .catch(() => {
        ErrorSetter("دریافت اطلاعات با مشکل مواجه شد. لطفا صفحه را رفرش کنید.");
      });
    //Getting Terms Data
    api
      .get(`/terms?student=${params.id}`, { headers: { ...AuthHeader } })
      .then((res) => {
        setTerms(res.data);
      })
      .catch(() => {
        ErrorSetter("دریافت اطلاعات با مشکل مواجه شد. لطفا صفحه را رفرش کنید.");
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  const addTerm = (values) => {
    LoadingSetter();
    let days = [];
    let times = [];
    if (values.class_time) {
      days = [...values.class_time].map((el) => el.day);
      times = [...values.class_time].map((el) => el.time);
    }
    const start_date = values.start_date
      ? dayjs(values.start_date).toISOString().split("T")[0]
      : null;

    delete values.class_time;
    api
      .post(
        `/terms`,
        { ...values, start_date, days, times, students: [params.id] },
        { headers: { ...AuthHeader } }
      )
      .then((res) => {
        NewTermForm.resetFields();
        const termsData = [...terms];
        termsData.push(res.data);
        setTerms(termsData);
        message.success("کلاس با موفقیت ایجاد شد.");
        setOpenNewTermModal(false);
        ClearLoading();
      })
      .catch(() => {
        ClearLoading();
        message.error("مشکلی در ثبت کلاس به وجود آمده");
      });
  };
  const deleteTerm = (id, element) => {
    LoadingSetter();
    api
      .delete(`/term/${id}`, { headers: { ...AuthHeader } })
      .then((res) => {
        console.log(res.data);
        setEditMode(false);
        setActiveCollapse("100000000");
        const TermsData = [...terms];

        const NewData = TermsData.filter((val, index) => {
          return TermsData.indexOf(element) !== index;
        });
        setTerms(NewData);
        ClearLoading();
        message.success("کلاس با موفقیت حذف شد.");
      })
      .catch(() => {
        ErrorSetter("مشکلی در حذف کلاس به وجود آمده است.");
        ClearLoading();
      });
  };
  const editTerm = (values, id, index) => {
    let days = [];
    let times = [];
    if (values.class_time) {
      days = [...values.class_time].map((el) => el.day);
      times = [...values.class_time].map((el) => el.time);
    }
    delete values.class_time;
    const start_date = values.start_date
      ? dayjs(values.start_date).toISOString().split("T")[0]
      : null;
    LoadingSetter();
    api
      .patch(
        `/term/${id}`,
        { ...values, start_date, days, times },
        { headers: { ...AuthHeader } }
      )
      .then((res) => {
        setEditMode(false);
        ClearLoading();
        const newTerms = terms;
        newTerms[index] = res.data;
        setTerms(newTerms);
        message.success("کلاس با موفقیت تغییر کرد.");
      })
      .catch(() => {
        ErrorSetter("مشکلی در تغییر کلاس به وجود آمده است.");
        ClearLoading();
      });
  };
  const sendTerm = (id) => {
    LoadingSetter();
    api
      .post("/send-term-sms", { id }, { headers: { ...AuthHeader } })
      .then((res) => {
        ClearLoading();
        message.success("اس ام اس اطلاع رسانی به کاربر ارسال شد.");
      })
      .catch(() => {
        ClearLoading();
        ErrorSetter("مشکلی در ارسال اس ام اس اطلاع رسانی پیش آمده.");
      });
  };
  const onSubmitPlacementTest = (values, id, index) => {
    LoadingSetter();
    delete values.recorded_voice;
    console.log(dayjs(values.study_amount, "HH:mm:ss").second());
    const studyAmount = values.study_amount
      ? `${dayjs(values.study_amount).hour()}:${dayjs(
          values.study_amount
        ).minute()}:${dayjs(values.study_amount).second()}`
      : 0;
    const deadline = values.deadline
      ? dayjs(values.deadline).toISOString().split("T")[0]
      : null;
    const personalities =  Array.isArray(values.personalities)
      ? values.personalities
      : [];
    const curriculum = Array.isArray(values.curriculum) && values.curriculum.map((item , index)=>{
      return {...item , order : index}
    })
    api
      .patch(
        "/placement-test/" + id,
        { ...values, study_amount: studyAmount, deadline, personalities , curriculum },
        { headers: { ...AuthHeader } }
      )
      .then((res) => {
        const newData = data;
        newData.placement_tests[index] = res.data;
        setData(newData);
        ClearLoading();
        setEditMode(false);
        message.success("اطلاعات با موفقیت ثبت شد.");
      })
      .catch(() => {
        ErrorSetter("مشکلی در ثبت اطلاعات تعیین سطح پیش آمده.");
        ClearLoading();
      });
  };
  const onSubmitSignUpForm = (values) => {
    LoadingSetter();
    console.log(values);
    api
      .patch(
        `/student/${params.id}`,
        {
          ...values,
          birth_date: values.birth_date
            ? dayjs(values.birth_date).toISOString().split("T")[0]
            : "",
        },
        { headers: { ...AuthHeader } }
      )
      .then((res) => {
        setData(res.data);
        setEditMode(false);
        ClearLoading();
        message.success("اطلاعات با موفقیت تغییر کرد.");
      })
      .catch(() => {
        ErrorSetter("در ثبت تغییرات مشکلی پیش آمده است.");
        ClearLoading();
      });
  };
  const SetStatus = (record, status, successMessage, onSuccessFunction) => {
    api
      .patch(
        "/student/" + record.id,
        { status },
        { headers: { ...AuthHeader } }
      )
      .then(() => {
        message.success(successMessage);
        ClearLoading();
        if (onSuccessFunction) {
          onSuccessFunction();
        }
      })
      .catch(() => {
        ClearLoading();
        ErrorSetter("مشکلی در تغییر وضعیت پیش آمده.");
      });
  };
  const SendTestResult = (placementTest) => {
    if (data) {
      if (
        placementTest.level !== null &&
        placementTest.curriculum.length > 0 &&
        placementTest.description
      ) {
        LoadingSetter();
        api
          .post(
            "/send-pt-result-sms",
            { id: placementTest.id },
            { headers: { ...AuthHeader } }
          )
          .then((res) => {
            const successMessage = "ارسال نتیجه تعیین سطح با موفقیت ثبت شد.";
            if (data.status === "TD") {
              SetStatus(data, "TE", successMessage);
            } else {
              ClearLoading();
              message.success(successMessage);
            }
          })
          .catch(() => {
            ErrorSetter("مشکلی در ارسال نتیجه تعیین سطح پیش آمده.");
            ClearLoading();
          });
      } else {
        message.error("اطلاعات تعیین سطح وارد نشده است.");
      }
    }
  };
  const onSubmitNotes = () => {
    LoadingSetter();

    api
      .patch(
        `/student/${params.id}`,
        { considerations: notes },
        { headers: { ...AuthHeader } }
      )
      .then((res) => {
        setEditMode(false);
        ClearLoading();
        message.success("یادداشت‌ها با موفقیت تغییر کرد.");
      })
      .catch(() => {
        ErrorSetter("در ثبت یادداشت‌ها مشکلی پیش آمده است.");
        ClearLoading();
      });
  };
  console.log(SignUpForm.getFieldInstance("first_name"));
  const darkMode = false;
  return (
    <div
      className={[
        styles.Student,
        darkMode ? styles.DarkMode + " DarkMode" : null,
        "Student",
      ].join(" ")}
    >
      <PageHeader
        avatar={{ icon: <UserOutlined />, size: "large" }}
        title={
          data ? (
            `${data.first_name} ${data.last_name}`
          ) : (
            <Skeleton.Input active />
          )
        }
        subTitle={
          data ? `| ${StatusSetter(data.status)}` : <Skeleton.Input active />
        }
      />
      <div className={styles.Content}>
        <Tabs
          onChange={(key) => {
            if (!editMode) {
              setActiveTab(key);
            }
          }}
          activeKey={activeTab}
          expandIconPosition="right"
          tabPosition="top"
          className={styles.Tabs}
        >
          <Tabs.TabPane
            tab={<div>{<UserAddOutlined />}اطلاعات ثبت نام</div>}
            key="SignUp"
            className={[styles.Tab, styles.SignUpForm].join(" ")}
          >
            {data ? (
              <div>
                <EditButton
                  loading={loading}
                  submit={SignUpForm.submit}
                  editMode={editMode}
                  ToggleEditMode={ToggleEditMode}
                  onCancel={() => {
                    SignUpForm.setFieldsValue({
                      ...data,
                      birth_date: data.birth_date
                        ? dayjs(data.birth_date)
                        : null,
                    });
                  }}
                />
                {!editMode && (
                  <div className={styles.FormExportDropdown}>
                    <FormExportDropdown
                      data={data}
                      mapper={SignUpFormMapper}
                      name={data.first_name + " " + data.last_name}
                    />
                  </div>
                )}
              </div>
            ) : null}
            {data ? (
              <Form
                initialValues={
                  data
                    ? {
                        ...data,
                        birth_date: data.birth_date
                          ? dayjs(data.birth_date)
                          : null,
                      }
                    : null
                }
                className={styles.SignUpFormdata}
                disabled={!editMode || loading}
                layout="vertical"
                form={SignUpForm}
                name="register"
                onFinish={onSubmitSignUpForm}
                scrollToFirstError
              >
                <SignUpInputs form={SignUpForm} />
              </Form>
            ) : (
              <Loading />
            )}
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={<div>{<FormOutlined />}تعیین سطح‌ها</div>}
            key="PlacementTest"
            className={styles.Tab}
          >
            {data ? (
              data.placement_tests.length === 0 ? (
                <Empty />
              ) : (
                <Collapse
                  activeKey={activeCollapse}
                  onChange={(key) => {
                    if (!editMode) {
                      setActiveCollapse(key);
                    }
                  }}
                  accordion
                  bordered={false}
                  expandIconPosition="right"
                >
                  {data.placement_tests.reverse().map((el, index) => {
                    return (
                      <Panel
                        key={index}
                        className={styles.Panel}
                        header={
                          <PageHeader
                            title={"تعیین سطح شماره " + (index + 1).toString()}
                            subTitle={
                              <div>
                                <span style={{ margin: "0 1rem" }}>
                                  <b> تاریخ : </b>
                                  <span>
                                    {el.jactive_due_date
                                      .split(" ")[0]
                                      .split("-")
                                      .join("/")}
                                  </span>
                                </span>
                                <span>
                                  <b> ساعت : </b>
                                  <span>
                                    {el.jactive_due_date
                                      .split(" ")[1]
                                      .replace("0", "")
                                      .replace("00", "0")
                                      .split(":")
                                      .map((el, index) => {
                                        let type = null;
                                        switch (index) {
                                          case 0:
                                            type = "و";
                                            break;
                                          case 1:
                                            type = "دقیقه";
                                            break;
                                          default:
                                            type = "";
                                        }
                                        return (
                                          <span>
                                            {" "}
                                            {index === 2 ? null : el} {type}{" "}
                                          </span>
                                        );
                                      })}{" "}
                                  </span>
                                </span>
                              </div>
                            }
                            avatar={{ icon: <EnterOutlined />, size: "small" }}
                          />
                        }
                      >
                        <PlacementTestForm
                          initialValues={el}
                          EditButton={EditButton}
                          editMode={editMode}
                          ToggleEditMode={ToggleEditMode}
                          exportFileName={
                            "تعیین سطح شماره " +
                            (index + 1).toString() +
                            " - " +
                            data.first_name +
                            " " +
                            data.last_name
                          }
                          levels={levels}
                          LevelSetter={LevelSetter}
                          onSubmit={(value) => {
                            onSubmitPlacementTest(value, el.id, index);
                          }}
                          uploadProps={{
                            name: "recorded_voice",
                            action: url + "/upload-voice/" + el.id,
                            headers: { ...AuthHeader },
                            method: "post",
                          }}
                          disabled={!editMode || loading}
                          loading={loading}
                        />
                        <Popconfirm
                          title="آیا مطمئن هستید که می‌خواهید نتیجه تعیین سطح برای کاربر ارسال شود؟"
                          onConfirm={() => {
                            SendTestResult(el);
                          }}
                        >
                          <Button loading={loading}>
                            اطلاع رسانی تعیین سطح
                          </Button>
                        </Popconfirm>
                      </Panel>
                    );
                  })}
                </Collapse>
              )
            ) : (
              <div>
                <Skeleton.Input size="large" block active />
                <Skeleton.Input
                  style={{ margin: "1rem 0" }}
                  size="large"
                  block
                  active
                />
                <Skeleton.Input size="large" block active />
              </div>
            )}
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={<div>{<CalendarOutlined />}کلاس‌ها</div>}
            key="Classes"
            className={styles.Tab}
          >
            <Button
              block
              type="dashed"
              className={styles.NewTermButton}
              onClick={() => {
                setOpenNewTermModal(true);
                NewTermForm.resetFields();
                NewTermForm.setFieldValue("session_count", 10);
              }}
              icon={<PlusOutlined />}
            >
              اضافه کردن کلاس جدید
            </Button>
            <Modal
              title="ایجاد کلاس جدید"
              centered
              open={openNewTermModal}
              onOk={() => {
                NewTermForm.submit();
              }}
              onCancel={() => setOpenNewTermModal(false)}
              okButtonProps={{ loading: loading }}
              visible={openNewTermModal}
              maskClosable={false}
              className={styles.NewTermModal}
              width="100%"
            >
              <TermForm
                EditButton={() => <div></div>}
                editMode={false}
                ToggleEditMode={ToggleEditMode}
                onSubmit={(value) => {
                  addTerm(value);
                }}
                newTerm
                newTermForm={NewTermForm}
                disabled={loading}
                loading={loading}
                levels={levels}
              />
            </Modal>
            {terms ? (
              terms.length === 0 ? (
                <Empty />
              ) : (
                <Collapse
                  activeKey={activeCollapse}
                  onChange={(key) => {
                    if (!editMode) {
                      setActiveCollapse(key);
                    }
                  }}
                  accordion
                  bordered={false}
                  expandIconPosition="right"
                >
                  {[...terms].reverse().map((el, index) => {
                    return (
                      <Panel
                        key={index}
                        className={[
                          styles.Panel,
                          index === 0 ? styles.ActiveTerm : null,
                        ].join(" ")}
                        header={
                          <PageHeader
                            className={styles.TermHeader}
                            title={
                              <span>{`${(
                                [...terms].length - index
                              ).toString()} -  ${
                                LevelSetter(el.level)
                                  ? LevelSetter(el.level)
                                  : "نامشخص"
                              } `}</span>
                            }
                            subTitle={
                              <span>
                                {" "}
                                {`| ${
                                  el.days ? [...el.days].join(" - ") : "نامشخص"
                                } / ${
                                  el.teacher_name ? el.teacher_name : "نامشخص"
                                }`}
                              </span>
                            }
                            avatar={{ icon: <EnterOutlined />, size: "small" }}
                          />
                        }
                      >
                        <TermForm
                          initialValues={el}
                          EditButton={EditButton}
                          editMode={editMode}
                          ToggleEditMode={ToggleEditMode}
                          onSubmit={(value) => {
                            editTerm(value, el.id, index);
                          }}
                          sendTerm={() => {
                            sendTerm(el.id);
                          }}
                          deleteTerm={() => {
                            deleteTerm(el.id, el);
                          }}
                          disabled={!editMode || loading}
                          loading={loading}
                          levels={levels}
                        />
                      </Panel>
                    );
                  })}
                </Collapse>
              )
            ) : (
              <div>
                <Skeleton.Input size="large" block active />
                <Skeleton.Input
                  style={{ margin: "1rem 0" }}
                  size="large"
                  block
                  active
                />
                <Skeleton.Input size="large" block active />
              </div>
            )}
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={<div>{<BookOutlined />}یادداشت‌ها</div>}
            key="Notes"
            className={styles.Tab}
          >
            {data ? (
              <div className={styles.Notes}>
                <EditButton
                  loading={loading}
                  submit={onSubmitNotes}
                  editMode={editMode}
                  ToggleEditMode={ToggleEditMode}
                  onCancel={() => {
                    setNotes(data.considerations);
                  }}
                />
                <TextEditor
                  disabled={!editMode}
                  value={notes}
                  onChange={(val) => {
                    setNotes(val);
                  }}
                  className={styles.NotesEditor}
                />
              </div>
            ) : (
              <Loading />
            )}
          </Tabs.TabPane>
        </Tabs>
      </div>
    </div>
  );
};
const EditButton = ({
  editMode,
  ToggleEditMode,
  submit,
  onCancel,
  loading,
}) => {
  return (
    <Space className={styles.EditButton}>
      {editMode ? (
        <Button loading={loading} type="primary" onClick={submit}>
          ثبت تغیرات
        </Button>
      ) : (
        <Button type="dashed" onClick={ToggleEditMode} icon={<EditOutlined />}>
          ویرایش
        </Button>
      )}
      {editMode ? (
        <Popconfirm
          title="آیا می‌خواهید انصراف دهید؟"
          disabled={loading}
          onConfirm={() => {
            ToggleEditMode();
            onCancel();
          }}
        >
          <Button disabled={loading} type="primary" danger>
            انصراف
          </Button>
        </Popconfirm>
      ) : null}
    </Space>
  );
};
const Loading = () => {
  return (
    <div className={styles.Loading}>
      <Spin size="large" />
      <br />
      <h3>در حال دریافت اطلاعات...</h3>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    token: state.token,
    loading: state.loading,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ErrorSetter: (error, errorType) =>
      dispatch(actions.ErrorSetter(error, errorType)),
    ClearError: () => dispatch(actions.ClearError()),
    LoadingSetter: (error, errorType) => dispatch(actions.LoadingSetter()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Student);
